module.exports = __webpack_public_path__ + "img/hero.880398e8.png";